/* eslint-disable */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransferableStatus = exports.TransferStatus = exports.RegistrarName = exports.RedeemStatusEnum = exports.PolicyReasonEnum = exports.LegalTypeEnum = exports.ICANNContactVerificationStatus = exports.EntityTypeEnum = exports.EligibilityTypeEnum = exports.EligibilityIdTypeEnum = exports.BillingProviderType = exports.AvailabilityStatus = void 0;
var AvailabilityStatus;
(function (AvailabilityStatus) {
    AvailabilityStatus["UNKNOWN"] = "UNKNOWN";
    AvailabilityStatus["AVAILABLE"] = "AVAILABLE";
    AvailabilityStatus["UNAVAILABLE"] = "UNAVAILABLE";
})(AvailabilityStatus = exports.AvailabilityStatus || (exports.AvailabilityStatus = {}));
var BillingProviderType;
(function (BillingProviderType) {
    BillingProviderType["UNKNOWN"] = "UNKNOWN";
    BillingProviderType["SBS"] = "SBS";
    BillingProviderType["RESELLER"] = "RESELLER";
})(BillingProviderType = exports.BillingProviderType || (exports.BillingProviderType = {}));
var EligibilityIdTypeEnum;
(function (EligibilityIdTypeEnum) {
    EligibilityIdTypeEnum["UNKNOWN"] = "UNKNOWN";
    EligibilityIdTypeEnum["ABN"] = "ABN";
    EligibilityIdTypeEnum["ACN"] = "ACN";
})(EligibilityIdTypeEnum = exports.EligibilityIdTypeEnum || (exports.EligibilityIdTypeEnum = {}));
var EligibilityTypeEnum;
(function (EligibilityTypeEnum) {
    EligibilityTypeEnum["UNKNOWN"] = "UNKNOWN";
    EligibilityTypeEnum["COM"] = "COM";
    EligibilityTypeEnum["STR"] = "STR";
    EligibilityTypeEnum["PRT"] = "PRT";
    EligibilityTypeEnum["TRO"] = "TRO";
    EligibilityTypeEnum["PTO"] = "PTO";
})(EligibilityTypeEnum = exports.EligibilityTypeEnum || (exports.EligibilityTypeEnum = {}));
var EntityTypeEnum;
(function (EntityTypeEnum) {
    EntityTypeEnum["UNKNOWN"] = "UNKNOWN";
    EntityTypeEnum["ITR"] = "ITR";
    EntityTypeEnum["FOR"] = "FOR";
    EntityTypeEnum["COM"] = "COM";
    EntityTypeEnum["FWI"] = "FWI";
    EntityTypeEnum["NPO"] = "NPO";
    EntityTypeEnum["POI"] = "POI";
    EntityTypeEnum["OSI"] = "OSI";
})(EntityTypeEnum = exports.EntityTypeEnum || (exports.EntityTypeEnum = {}));
var ICANNContactVerificationStatus;
(function (ICANNContactVerificationStatus) {
    ICANNContactVerificationStatus["VERIFICATION_STATUS_UNKNOWN"] = "VERIFICATION_STATUS_UNKNOWN";
    ICANNContactVerificationStatus["PENDING"] = "PENDING";
    ICANNContactVerificationStatus["DEACTIVATED"] = "DEACTIVATED";
    ICANNContactVerificationStatus["VERIFIED"] = "VERIFIED";
})(ICANNContactVerificationStatus = exports.ICANNContactVerificationStatus || (exports.ICANNContactVerificationStatus = {}));
var LegalTypeEnum;
(function (LegalTypeEnum) {
    LegalTypeEnum["UNKNOWN"] = "UNKNOWN";
    LegalTypeEnum["ABO"] = "ABO";
    LegalTypeEnum["ASS"] = "ASS";
    LegalTypeEnum["CCO"] = "CCO";
    LegalTypeEnum["CCT"] = "CCT";
    LegalTypeEnum["EDU"] = "EDU";
    LegalTypeEnum["GOV"] = "GOV";
    LegalTypeEnum["HOP"] = "HOP";
    LegalTypeEnum["INB"] = "INB";
    LegalTypeEnum["LAM"] = "LAM";
    LegalTypeEnum["LGR"] = "LGR";
    LegalTypeEnum["MAJ"] = "MAJ";
    LegalTypeEnum["OMK"] = "OMK";
    LegalTypeEnum["PLT"] = "PLT";
    LegalTypeEnum["PRT"] = "PRT";
    LegalTypeEnum["RES"] = "RES";
    LegalTypeEnum["TDM"] = "TDM";
    LegalTypeEnum["TRD"] = "TRD";
    LegalTypeEnum["TRS"] = "TRS";
})(LegalTypeEnum = exports.LegalTypeEnum || (exports.LegalTypeEnum = {}));
var PolicyReasonEnum;
(function (PolicyReasonEnum) {
    PolicyReasonEnum["UNKNOWN"] = "UNKNOWN";
    PolicyReasonEnum["EXC"] = "EXC";
    PolicyReasonEnum["CLS"] = "CLS";
})(PolicyReasonEnum = exports.PolicyReasonEnum || (exports.PolicyReasonEnum = {}));
var RedeemStatusEnum;
(function (RedeemStatusEnum) {
    RedeemStatusEnum["UNKNOWN_REDEEM_STATUS"] = "UNKNOWN_REDEEM_STATUS";
    RedeemStatusEnum["CAN_REDEEM"] = "CAN_REDEEM";
    RedeemStatusEnum["REDEEM_IN_PROGRESS"] = "REDEEM_IN_PROGRESS";
    RedeemStatusEnum["REDEEM_FAILED"] = "REDEEM_FAILED";
    RedeemStatusEnum["CANNOT_REDEEM"] = "CANNOT_REDEEM";
})(RedeemStatusEnum = exports.RedeemStatusEnum || (exports.RedeemStatusEnum = {}));
var RegistrarName;
(function (RegistrarName) {
    RegistrarName["UNKNOWN"] = "UNKNOWN";
    RegistrarName["REGISTER_DOT_COM"] = "REGISTER_DOT_COM";
    RegistrarName["TUCOWS"] = "TUCOWS";
    RegistrarName["WIX"] = "WIX";
})(RegistrarName = exports.RegistrarName || (exports.RegistrarName = {}));
var TransferStatus;
(function (TransferStatus) {
    TransferStatus["UNDEF"] = "UNDEF";
    TransferStatus["PENDING_OWNER"] = "PENDING_OWNER";
    TransferStatus["PENDING_ADMIN"] = "PENDING_ADMIN";
    TransferStatus["PENDING_REGISTRY"] = "PENDING_REGISTRY";
    TransferStatus["COMPLETED"] = "COMPLETED";
    TransferStatus["CANCELLED"] = "CANCELLED";
})(TransferStatus = exports.TransferStatus || (exports.TransferStatus = {}));
var TransferableStatus;
(function (TransferableStatus) {
    TransferableStatus["ALLOWED"] = "ALLOWED";
    TransferableStatus["NOT_ALLOWED"] = "NOT_ALLOWED";
    TransferableStatus["LOCKED"] = "LOCKED";
    TransferableStatus["DOMAIN_DOES_NOT_EXIST"] = "DOMAIN_DOES_NOT_EXIST";
})(TransferableStatus = exports.TransferableStatus || (exports.TransferableStatus = {}));
//# sourceMappingURL=types.js.map